import React, { useEffect } from 'react'
import './Explore_Latest_Products.css'
import Explore_Latest_Banner from './explore_latest_banner/Explore_Latest_Banner'
import Breadcrumb_Comp from '../common/common_components/breadcrumb_comp/Breadcrumb_Comp';
import Explore_top_products from '../explore/explore-top-products/Explore_top_products';
import Combo_Offer_Swiper from './combo_offer_swiper/Combo_Offer_Swiper';
import Peoples_Choice from './peoples_choice/Peoples_Choice';
import All_Products from './all_products/All_Products';
import { AllStoreBanners } from '../../features/admin/common/Slice';
import { useDispatch, useSelector } from 'react-redux';
import { IDS } from '../../utils/IDS';

const Explore_Latest_Products = () => {
  const dispatch = useDispatch()
  const storeBanners = useSelector((state) => state.common.all_store_banner);

  useEffect(() => {
    dispatch(AllStoreBanners());
  }, [dispatch]);


  const banners = [
    `${IDS.IMG_URL + storeBanners?.[0]?.image}` || "/assets/images/explore/explore_latest_products/explore_banner.png",
  ];

  const swiperBanners = storeBanners.slice(1)


  return (
    <section className='Explore_Latest_Products'>
      <Explore_Latest_Banner banner={banners[0]} />
      <Explore_top_products />
      <Combo_Offer_Swiper data={swiperBanners} />
      <Peoples_Choice />
      <All_Products />
    </section>
  )
}

export default Explore_Latest_Products
